import StringUtil from '@leverege/string-util';
function aggBucketToLabel(result, trueValue = 'True', falseValue = 'False') {
  if (result.key === 1) {
    return trueValue;
  }
  if (result.key === 0) {
    return falseValue;
  }
  return result.key;
}
function aggTypeToName(type) {
  if (type == null) {
    return null;
  }
  const parts = type.split('.');
  return StringUtil.camelCaseToTitleCase(parts[1]);
}
function roundTo(value, places = 2) {
  const factorOfTen = 10 ** places;
  return Math.round((value + Number.EPSILON) * factorOfTen) / factorOfTen;
}
export default {
  aggBucketToLabel,
  aggTypeToName,
  roundTo
};